import { ReactNode } from 'react';
import { IApiResponse, ITransferBeneficiary } from 'utils/models';

export const sortArrays = [
  'Source Account:',
  'Transfer Type:',
  'Bank:',
  'Destination Bank:',
  'Destination Account:',
  'Beneficiary Name:',
  'Narration:',
  'Transaction Fee:',
  'Transaction Amount:',
  'Amount:',
  'Total Amount:',
];

export const sortWithScheduleArrays = [
  'Source Account:',
  'Transfer Type:',
  'Bank:',
  'Destination Bank:',
  'Destination Account:',
  'Beneficiary Name:',
  'Narration:',
  'Transaction Fee:',
  'Transaction Amount:',
  'Amount:',
  'Total Amount:',
  'Frequency:',
  'Special Date:',
];

export const FAB_BANK = { code: '300316', name: 'First Atlantic Bank' };

export type BankTypeKeys = 'INSTANT' | 'NON_INSTANT';

export const types = [
  { name: 'INSTANT TRANSFER', key: 'INSTANT' },
  { name: 'NON-INSTANT TRANSFER', key: 'NON_INSTANT' },
];

export enum TransactionType {
  LOCAL ='LOCAL',
  INSTANT_INTERBANK = 'INSTANT_INTERBANK',
  NON_INSTANT_INTERBANK = 'NON_INSTANT_INTERBANK',
}
export interface IExtraFields {
  destinationBankName: string;
  destinationBankCode: string;
  destinationAccountName: string;
  destinationIsExistingBen: boolean;
  beneficiaryId?: number;
  charge?: number;
}

export interface ITransfersState {
  transferBeneficiaries: ITransferBeneficiary[];
  banks: IBank[];
  types: typeof types;
  isLookingUp?: boolean;
  extras: IExtraFields;
  lastLookedUpAccount: string;
  lastLookedUpBankCode: string;
}

export interface IFormValues {
  sourceAccount: string;
  amount: number | string;
  destinationAccountNo: string;
  narration: string;
  destinationBankCode: string;
  transferType: BankTypeKeys;
  beneficiaryName?: string;
  scheduleTransfer?: boolean;
  frequency: string;
  startDate: string;
}

export interface ITransactionField {
  label: ReactNode;
  value: ReactNode;
}

export interface IBank {
  code: string;
  name: string;
}

export interface ITransferResponse extends IApiResponse {
  transactionId: number;
}

export interface IAccountLookup {
  name: string;
  beneficiaryId?: number;
}

export interface ILocalLookupRes extends IApiResponse {
  accountName: string;
}

export interface IGetTransferBeneficiaries extends IApiResponse {
  beneficiaries: ITransferBeneficiary[];
}

export interface IGetBankInstitutions extends IApiResponse {
  banks: IInstantBank[];
}

export interface INonInstantBank {
  BankSortCode: string;
  BankName: string;
  BankShortName: string;
}

export interface IInstantBank {
  code: string;
  name: string;
}

export type IBanksMappedList = { INSTANT: IBank[]; NON_INSTANT: IBank[] };

export interface IGetNonInstantBanks extends IApiResponse {
  banks: INonInstantBank[];
}

export interface ITransferCharge extends IApiResponse {
  charge: number;
}

export interface ITransferActions {
  getTransactionCharge: (amount: string | number, type: string) => void;
  findBeneficiaryName: (values: IFormValues) => void;
  handleSelectBank: (bankCode: string) => void;
  fetchBeneficiaries: (values: IFormValues) => void;
}

export interface IOtherLookupRes extends IApiResponse {
  beneficiaryId: number;
  name: string;
}

export type IHandleFieldsChange = () => void;
